import { Drawer as MuiDrawer } from '@mui/material';
import type { DrawerProps as MuiDrawerProps } from '@mui/material/Drawer';

export type DrawerProps = MuiDrawerProps;

export const Drawer = ({ ...rest }: DrawerProps): JSX.Element => <MuiDrawer {...rest} />;
